// extracted by mini-css-extract-plugin
export var cardsList = "inventory-module--cardsList--3b89d";
export var cardsListScrollable = "inventory-module--cardsListScrollable--ced8f";
export var infoText = "inventory-module--infoText--40f55";
export var inventoryLevels = "inventory-module--inventoryLevels--4c139";
export var inventoryLevelsHeading = "inventory-module--inventoryLevelsHeading--a55b0";